import { apiClient } from './api'
import { resolveEventId } from './eventService'

export interface ProfileComplete {
  avatarKind: 'photo' | 'preset' | 'initials'
  photoUrl?: string | null
  avatarPreset?: string | null
  avatarColor?: string | null
  initials?: string | null
  bio: string
  headline: string
  linkedinUrl?: string | null
  websiteUrl?: string | null
}

export const profileService = {
  /** Upload a headshot; returns the served URL to store on the profile. */
  uploadPhoto: async (file: File): Promise<string> => {
    const id = await resolveEventId()
    const form = new FormData()
    form.append('file', file)
    // Do NOT set Content-Type manually: the browser/axios must set
    // `multipart/form-data; boundary=…` itself. Hard-coding it without the
    // boundary makes the server reject the body ("Missing boundary in
    // multipart"), which then cascaded into a spurious auth error.
    const { data } = await apiClient.post<{ url: string }>(
      `/events/${id}/attendee/photo`,
      form,
    )
    return data.url
  },

  /** Save the required onboarding profile and clear the onboarding gate. */
  complete: async (payload: ProfileComplete): Promise<void> => {
    const id = await resolveEventId()
    await apiClient.post(`/events/${id}/attendee/profile/complete`, payload)
  },
}
